import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { MyContext } from "../../../MyContext";
import API from "../../Api";
import { useSession } from "../../session/Context";
import { toast } from "react-toastify";

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import CSVReader from "../../CSVReader";
import { UploadFile } from "@mui/icons-material";
import { Navigate, useNavigate } from "react-router-dom";
import Input from "../../schema/Input";
import { getCredentialSubject } from "../../schema/Utils";
import { FormControl } from "@mui/material";

interface CreateCredentialProps {
  scope: any;
}

export default function SingleCreateCredential(props: CreateCredentialProps) {
  const { brand } = useSession();
  const navigate = useNavigate();
  const [selectScopes, setSelectScopes] = useState<any[]>([]);
  const [selectedScope, setSelectedScope] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [selectedAuthType, setSelectedAuthType] = useState("");

  // Part two
  const [email, setEmail] = useState("");

  const [data, setData] = useState<any>({});

  const { onPage, setOnPage } = useContext(MyContext)!;

  // Get credential types
  useEffect(() => {
    setSelectScopes(
      Object.keys(props.scope)
        .map((scope) => props.scope[scope])
        .filter((scope) => scope.factory === "Schema Factory")
        .map((scope) => {
          return {
            label: scope.schema.content.title,
            value: scope.scope,
            tooltip: scope.schema.content.description,
          };
        })
    );
  }, []);

  const onCreateCredential = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    const body = {
      type: props.scope[selectedScope].id,
      email: email,
      subject: data,
    };

    if (props.scope[selectedScope].id === "authorized.verifier.credential.v1") {
      body.subject = {
        permissions: [
          {
            type: props.scope[selectedAuthType].metadata.types[
              props.scope[selectedAuthType].metadata.types.length - 1
            ],
          },
        ],
      };
    }

    API("/api/v1/brand" + (brand == "" ? "/root" : "/" + brand) + "/offer", {
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((response) => {
          console.log(response);

          if(response.type === "mail"){
            //window.open(response);
            toast.success("New credential was send to selected email.", {
                theme: "colored",
            });
            setOnPage("dashboard");
            navigate("/dashboard");
          } else if(response.type === "link"){
            navigate("/issuance_details?id="+response.id);
          }

        
      })
      .catch((error) => {
        console.error(error);
        toast.error("Error creating credential " + error, { theme: "colored" });
      });
  };

  const handleChangeScope = (event: SelectChangeEvent) => {
    setSelectedScope(event.target.value);

    /* setSelectedIndex(event.target.selectedIndex); */
    setData({});
  };

  const onChangeEmail = (event: any) => {
    setEmail(event.target.value);
  };

  return (
    <>
      <div className="cards ">
        <div className="issue-credentials">
          <form onSubmit={onCreateCredential} className="form">
            <label>Recipient's Email</label>
            <input
              className="template-field"
              name="types"
              type="text"
              value={email}
              onChange={onChangeEmail}
              placeholder="Enter Recipient's Email"
              style={{ fontFamily: "Saira", fontSize: "15px" }}
              /*required*/
            ></input>
            <div className="add_issuance__cards">
              <div className="cards">
                <div>
                  <label>Credential Template</label>
                  <Select
                    required
                    className="template-field"
                    value={selectedScope}
                    onChange={handleChangeScope}
                    displayEmpty
                    renderValue={(value) => {
                      if (value == "") {
                        return (
                          <em style={{ color: "#8e8e8e", fontSize: "15px" }}>
                            Select Credential Template
                          </em>
                        );
                      } else {
                        return (
                          <em style={{ fontSize: "15px" }}>
                            {props.scope[selectedScope].schema.content.title}
                          </em>
                        );
                      }
                    }}
                  >
                    {selectScopes ? (
                      selectScopes.map((item, index) => {
                        return (
                          <MenuItem
                            selected={index === 0}
                            key={item.value}
                            value={item.value}
                          >
                            {item.label}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Select>
                </div>
              </div>
            </div>

            {(props.scope[selectedScope] &&
              props.scope[selectedScope].id !==
                "authorized.verifier.credential.v1") ||
            selectedScope === "" ? (
              <>
                {selectedScope !== "" && (
                  <Input
                    content={getCredentialSubject(
                      props.scope[selectedScope].schema.content
                    )}
                    required
                    onChange={(val) => {
                      setData(val);
                    }}
                  ></Input>
                )}
              </>
            ) : (
              <>
                <label>Authorize Recipient's Verification Permissions</label>
                <Select
                  required
                  className="template-field"
                  value={selectedAuthType}
                  onChange={(event: SelectChangeEvent) => {
                    setSelectedAuthType(event.target.value);
                  }}
                  displayEmpty
                  renderValue={(value) => {
                    if (value == "") {
                      return (
                        <em style={{ color: "#8e8e8e", fontSize: "15px" }}>
                          Select Credential Template
                        </em>
                      );
                    } else {
                      return (
                        <em style={{ fontSize: "15px" }}>
                          {props.scope[selectedAuthType].schema.content.title}
                        </em>
                      );
                    }
                  }}
                >
                  {selectScopes
                    .filter(
                      (item) => item.id !== "authorized.verifier.credential.v1"
                    )
                    .map((item, index) => {
                      return (
                        <MenuItem
                          selected={index === 0}
                          key={item.value}
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })}
                </Select>
              </>
            )}

            <input
              className="form-submit-btn btn btn-primary issuance__btn"
              key="submit"
              type="submit"
              value="Issue Credential"
            ></input>
          </form>
        </div>
      </div>
    </>
  );
}
